<p-overlayPanel #overlayPanel [showCloseIcon]="true">
	<ng-content></ng-content>
</p-overlayPanel>
